export default __webpack_public_path__ + "media/src/assets/images/income-11411f1e16aff395692a9f8c8e50f586.png";